module.exports = __webpack_public_path__ + "media/images/active_material/icons/account_circle-9fee81dd8843df0fbeb17ed198949371.svg";